import config from '../config';
import Logger from '../logger';
import event from '../mixins/event';

class ThemeToast {

	// Vars
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

	/**
	 * Class constructor
	 */
	constructor(dom) {

		this.NAME = 'ThemeToast';

		this.dom = dom;
		this.domActiveClass = 'theme-toast--active';
		this.contentDom = this.dom.querySelector('[data-theme-toast-content]');
	}

	/**
	 * init - Initialize the component
	 **/
	init() {
		Logger.info(`${this.NAME} > init`);
		this.hideToast();

		// Listen for window event
		window.addEventListener('toast:show', (event) => {
			const msg = event.detail.msg;
			const duration = event.detail.duration;
			if (!msg) return;
			this.showToast(msg, duration);
		});

		window.addEventListener('toast:hide', () => {
			this.hideToast();
		});
	}

	/**
	 * hideToast
	 */
	hideToast() {
		Logger.info(`${this.NAME} > hideToast`);
		this.dom.classList.remove(this.domActiveClass);
	}

	/**
	 * showToast
	 */
	showToast(msg, duration) {
		Logger.info(`${this.NAME} > showToast`);
		if (!msg) return;
		if (!duration) duration = 4000;
		this.contentDom.textContent = msg;
		this.dom.classList.add(this.domActiveClass);

		setTimeout(() => {
			this.hideToast();
		}, duration);
	}

}

Object.assign(ThemeToast.prototype, event);

export default ThemeToast;
